import React from "react";
import CommentInput from "../../../components/CommentInput";
export default function InputComment({
  commentContent,
  setCommentContent,
  submitReplyComment,
  typeInput,
  comment,
  current_user,
}) {
  return (
    <div className="box-child-cmt">
      <img
        className="bg-img-orgnal avtar40 position-absolute img-cmt-box"
        style={{ paddingTop: "0", width: "40px", height: "40px", left: "0" }}
        src={current_user?.image ?? "/images/avatar.png"}
        alt=""
      />

      <CommentInput
        component="div"
        onChange={setCommentContent}
        content={
          typeInput === "reply"
            ? commentContent
            : typeInput === "edit"
            ? comment.content
            : ""
        }
        placeholder={"Nhập nội dung"}
        typeInput={typeInput}
      />
      <div className="d-flex justify-content-end mt-2">
        <div
          className="position-absolute btn-send-cmt"
          style={{
            backgroundImage: 'url("/images/send-message.png")',
            width: "23px",
            height: "23px",
          }}
          onClick={() =>
            submitReplyComment(comment.id, commentContent, comment.user_id)
          }
        ></div>
      </div>
    </div>
  );
}
